
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.085 4.08A.75.75 0 0011.75 4h-8.5a.75.75 0 00-.375 1.4v13.2A.75.75 0 003.25 20h17.5a.75.75 0 00.375-1.4V9.9a.75.75 0 00-.04-1.32l-9-4.5zm8.29 5.821l-2.75-1.375V18.5h2.75V9.901zm-3.5-1.75V18.5h-2.75V6.776l2.75 1.375zm-3.5-1.75L11.573 5.5h-.948v13h2.75V6.401zm-3.5-.901v13h-2.75v-13h2.75zm-3.5 0h-2.75v13h2.75v-13z"}})])
          )
        }
      }
    